import React from 'react';
import PropTypes from 'prop-types'; // Add PropTypes if you're not using TypeScript
import { motion } from 'framer-motion';
import { ArrowUpIcon, ArrowDownIcon } from '@heroicons/react/solid';

const ProfitCard = ({ totalProfit = 0, percentageChange = 0, title = "Total Profit" }) => {
  const isPositive = percentageChange > 0;
  const profitTextColor = isPositive ? 'text-green-500' : 'text-red-500';
  const arrowIcon = isPositive ? (
    <ArrowUpIcon className="w-6 h-6" aria-label="Profit increase" />
  ) : (
    <ArrowDownIcon className="w-6 h-6" aria-label="Profit decrease" />
  );

  const cardAnimation = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
  };

  const percentageAnimation = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.3, ease: 'easeInOut' } },
  };

  const shouldHidePercentage = title === "Deposit" || title === "Account Balance";

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={cardAnimation}
      className="bg-white shadow-lg rounded-lg p-6 flex flex-col items-center justify-center transform transition-transform hover:scale-105 hover:shadow-2xl"
    >
      <h2 className="text-xl font-semibold mb-2 text-gray-700">{title}</h2>
      <p className="text-3xl font-bold text-gray-900 mb-2">
        ${totalProfit.toLocaleString()}
      </p>
      {!shouldHidePercentage && (
        <motion.div
          initial="hidden"
          animate="visible"
          variants={percentageAnimation}
          className="flex items-center mt-4"
        >
          {arrowIcon}
          <p className={`text-sm ml-2 font-medium ${profitTextColor}`}>
            {percentageChange}%
          </p>
        </motion.div>
      )}
    </motion.div>
  );
};

ProfitCard.propTypes = {
  totalProfit: PropTypes.number,
  percentageChange: PropTypes.number,
  title: PropTypes.string,
};

export default ProfitCard;

